module.exports = __webpack_public_path__ + "static/img/ciphertext-retrieval.b35ac1ff.png";